var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1498_5292)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1498_5292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 14.0898C11.59 14.0898 11.25 13.7498 11.25 13.3398V8.33984C11.25 7.92984 11.59 7.58984 12 7.58984C12.41 7.58984 12.75 7.92984 12.75 8.33984V13.3398C12.75 13.7498 12.41 14.0898 12 14.0898Z",
    fill: "#392C7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8906 3.78984H9.11062C8.71062 3.78984 8.39062 3.46984 8.39062 3.06984C8.39062 2.66984 8.71062 2.33984 9.11062 2.33984H14.8906C15.2906 2.33984 15.6106 2.65984 15.6106 3.05984C15.6106 3.45984 15.2906 3.78984 14.8906 3.78984Z",
    fill: "#392C7D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.0021 20.31V17.37C15.0021 16.1 15.7621 15.34 17.0321 15.34H19.9721C20.1621 15.34 20.3321 15.36 20.5021 15.4C20.6121 14.84 20.6721 14.26 20.6721 13.67C20.6721 8.89 16.7821 5 12.0021 5C7.22203 5 3.33203 8.89 3.33203 13.67C3.33203 18.45 7.22203 22.34 12.0021 22.34C13.2121 22.34 14.3621 22.09 15.4121 21.64C15.1521 21.3 15.0021 20.86 15.0021 20.31Z",
    fill: "#392C7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.97 15.3398H17.03C15.76 15.3398 15 16.0998 15 17.3698V20.3098C15 21.5798 15.76 22.3398 17.03 22.3398H19.97C21.24 22.3398 22 21.5798 22 20.3098V17.3698C22 16.0998 21.24 15.3398 19.97 15.3398ZM19.69 19.7998L18.51 20.4798C18.27 20.6198 18.03 20.6898 17.81 20.6898C17.64 20.6898 17.49 20.6498 17.35 20.5698C17.03 20.3798 16.85 20.0098 16.85 19.5198V18.1598C16.85 17.6698 17.03 17.2998 17.35 17.1098C17.67 16.9198 18.08 16.9598 18.51 17.1998L19.69 17.8798C20.11 18.1298 20.35 18.4698 20.35 18.8398C20.35 19.2098 20.12 19.5498 19.69 19.7998Z",
    fill: "#392C7D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1498_5292"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.339844)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1498_5292"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.339844)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg2);
export default __webpack_public_path__ + "static/media/img2.73cea9a83cec40851e3273d200205ae3.svg";
export { ForwardRef as ReactComponent };